<template>

    <update-score :course_id="course_id" :type="type" />

</template>

<script>
import UpdateScore from "./UpdateScore.vue";

export default {
    name: "LaboratoryInternalExam",

    components: {
        UpdateScore
    },

    props: ["course_id"],

    data() {
        return {
            type: 'internal_exam'
        };
    }
};
</script>
